import "@grapecity/wijmo.styles/wijmo.css";
import { TabPanel, Tab } from "@grapecity/wijmo.react.nav";
import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import styles from "./E3Tab.module.css";
/**
 * E3Tab
 * @type React.FC<E3TabPropTypes>
 */
const E3Tab = React.forwardRef((props, ref) => {
  Object.keys(props).forEach((p) => {
    if (!Object.keys(E3TabPropTypes).includes(p)) {
      console.error(`E3Tab: 정의되지 않은 prop ${p}가 전달되었습니다.`);
      console.warn(styles.a);
    }
  });

  /** 외부에서 접근할 수 있는 함수들 */
  React.useImperativeHandle(ref, () => ({
    setSelectedIndex(index) {
      setCurrState((prev) => ({
        ...prev,
        selectedIndex: index,
      }));
    },

    getSelectIndex() {
      return currState.selectedIndex;
    },
  }));

  const [currState, setCurrState] = useState({
    selectedIndex: props.selectedIndex ?? 0,
  });

  const tabJsx = [];
  for (let i = 0; i < props.tabs?.length; i++) {
    tabJsx.push(
      <Tab key={`tab_${i}`}>
        <a>{props.tabs[i].header}</a>
        <div>{props.tabs[i].content}</div>
      </Tab>
    );
  }

  const refTabPanel = useRef();

  const selectedIndexChanged = (panel) => {
    setCurrState((prev) => ({
      ...prev,
      selectedIndex: panel.selectedIndex,
    }));
  };

  return (
    <TabPanel
      ref={refTabPanel}
      className={"tabs-below"}
      selectedIndex={currState.selectedIndex}
      selectedIndexChanged={(panel) => selectedIndexChanged(panel)}
    >
      {tabJsx}
    </TabPanel>
  );
});

const E3TabPropTypes = {
  children: PropTypes.node,
  selectedIndex: PropTypes.number,
  tabs: PropTypes.array,
};
E3Tab.propTypes = E3TabPropTypes;
E3Tab.defaultProps = {
  selectedIndex: 0,
};
E3Tab.displayName = "E3Tab";

export default E3Tab;
